import React from "react";
import PayCard from "../layout/PayCard";
import LogNav from "../layout/LoggedNav";
import PayConfBar from "../layout/PayConfirmDetailBar";
import RenewPayBar from "../layout/RenewPayBar"

const RenewPayment = () => {
    return (
        <>
            <div className="curses_pay">
                <h1 className="curses_pay-title text-jost-sb-50-wt">Welcome to your account</h1>
                {/* <LogNav/> */}
                <div className="curses_pay__wrap">
                    <RenewPayBar/>
                    <PayCard/>
                </div>
            </div>
        </>
    );
};

export default RenewPayment;